export enum MilitaryLeaveReason {
    CARE_FOR_A_COVERED_SERVICE_MEMBER = 'Care for a covered service member',
    QUALIFYING_EXIGENCY_LEAVE = 'Qualifying exigency leave'
}